import script from "./slideProductSeven.vue?vue&type=script&setup=true&lang=js"
export * from "./slideProductSeven.vue?vue&type=script&setup=true&lang=js"

import "./slideProductSeven.vue?vue&type=style&index=0&id=b1f14ed0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b1f14ed0"]])

export default __exports__